<template src="./ConsultantsRegistered.html">

</template>

<script>
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      consultant: []
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getConsultants();
    },
    getConsultants() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "/admin/findAllConsultant",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.consultant = response.data;

          }
        });
    }
  }
};
</script>

<style src="./ConsultantsRegistered.css">

</style>